<template>
  <div id="shop">
    <ShopSlider></ShopSlider>
    <div style="padding-bottom: 30px; background-color: #535455">
      <div class="row carrello">
        <div class="col-lg-6 col-sm-6 col-md-6 col-6">
          <router-link :to="{name: 'homepage'}">Home</router-link>
          / Schede Prodotto
        </div>
      </div>
      <div class="row indice">
        <div style="margin: auto">
          <a class="link" v-for="(category, index) in categories" v-if="category.nome !== 'Regalistica'" v-scroll-to="'#'+category.nome">{{category.nome}}</a>
         <!-- <a class="link" v-for="(category, index) in categories" v-if="category.nome === 'Regalistica'" v-scroll-to="'#'+category.nome">Regala un'esperienza</a>-->
        </div>
      </div>
      <div class="row riga" v-for="(category, index) in categories">
        <div v-if="category.nome !== 'Regalistica'" class="categoria" v-bind:id="category.nome">{{category.nome}}</div>
       <!-- <div v-else class="categoria" v-bind:id="category.nome">Regala un'esperienza</div>-->
        <category v-if="category.nome !== 'Regalistica'" :category="category.nome"></category>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import MainSlider from './MainSlider'
  import Footer from './Footer'
  import ShopSlider from "./ShopSlider"
  import Category from "./Category"
  import PresentBox from "./PresentBox";

  export default {
    name: 'Shop',
    components: {PresentBox, ShopSlider, Footer, MainSlider, Category},
    data() {
      return {
        cart: [],
        categories: [],
        boxes: [],
        total: 0,
        router: ''
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          header: {
            all: 'Tutto',
            stocks: 'Riserve',
            spumanti: 'Spumanti',
            still: 'Rossi',
            sparkling: 'Bianchi'
          }
        },
        en: {
          header: {
            all: 'All',
            sstocks: 'Riserve',
            spumanti: 'Spumanti',
            still: 'Red',
            sparkling: 'White'
          }
        }
      }
    },
    mounted: function () {
      this.getCategories()
      // if (localStorage.getItem('idCarrello')) this.listCart()
    },
    methods: {
      scrollTo: function () {
        if (this.$route.params.catVino !== undefined) {
          this.$scrollTo('#' + this.$route.params.catVino, 500)
        }
      },
      getCategories: function () {
        this.categories = [{
          'id': 0,
          'nome': 'Rossi'
        }, {
          'id': 0,
          'nome': 'Bianchi'
        }, {
          'id': 0,
          'nome': 'Spumanti'
        }, {
          'id': 0,
          'nome': 'Riserve'
        }, {
          'id': 0,
          'nome': 'Regalistica'
        }]
        setTimeout(function () {
          this.scrollTo()
        }, 400)
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #shop {
    color: white;
    width: 100%;
    margin-left: 0px;
    .main {
      .agile {
        .agile__track {
          max-height: 410px;
        }
      }
    }
    .row {
      margin-left: 0px;
      margin-right: 0px;
    }
    .carrello {
      background-color: #585353;
      padding: 20px;
      .set-font-latoLight();
      .detailcar {
        text-align: right;
        width: 15%;
        #car {
          position: relative;
          width: 45px;
        }
        .numprod {
          color: orange;
          position: absolute;
          right: 18px;
          top: -5px;
          font-weight: bold;
          width: 35px;
          text-align: center;
        }
      }
    }
    .indice {
      background-color: @lightBlack;
      text-align: center;
      padding: 20px;
      .link {
        padding: 10px;
        padding-right: 50px;
        .set-font-latoMedium(@size: 25px);
      }
    }
    .riga {
      background-color: #585353;
      .categoria {
        width: 88%;
        margin: auto;
        text-align: center;
        padding: 20px;
        padding-top: 50px;
        border-bottom: 1px solid white;
        .set-font-title(@size: 30px);
      }
      .cont{
        margin-top: 50px;
        padding-right: 0px;
        padding-left: 0px;
      }
    }
    .categoria:after {
      border: 1px solid white;
    }
  }

  @media (max-width: 767px) {
    #shop {
      .carrello {
        .set-font-latoLight(@size: 13px);
        padding-left: 10px;
        padding-right: 10px;
        letter-spacing: 1px;
        #car {
          width: 30%;
        }
      }
      .indice {
        .link {
          padding-right: 5px;
          .set-font-latoMedium(@size: 13px);
        }
      }
      .riga {
        .categoria {
          padding: 10px;
          padding-top: 60px;
          .set-font-latoLight(@size: 23px);
        }
        .cont {
          margin-bottom: 25px;
          margin-top: 25px;
          .vino {
            .set-font-title(@size: 25px);
            padding: 0px;
            .nomeVino {
              .set-font-latoLight(@size: 23px);
            }
            .quantity {
              padding-right: 10px;
              .set-font-latoRegular(@size: 16px);
              .quantità {
              }
            }
            .immagine {
            }
            .desc {
              .set-font-latoLight(@size: 11px);
              padding-bottom: 10px;
            }
            .price {
              .set-font-latoRegular(@size: 16px, @color: light-green);
            }
            .scheda {
              .set-font-latoBold(@size: 16px);
            }
            .info {
              padding-left: 5px;
              padding-right: 5px;
              width: 100% !important;
              .set-font-latoLight(@size: 16px);
            }
          }
          .notvino {
            .set-font-title(@size: 25px);
            padding: 0px;
            .nomeVino {
              .set-font-latoLight(@size: 23px);
            }
            .quantity {
              padding-right: 10px;
              .set-font-latoRegular(@size: 16px);
              .quantità {
              }
            }
            .notimmagine {
            }
            .desc {
              .set-font-latoLight(@size: 11px);
              padding-bottom: 10px;
            }
            .price {
              .set-font-latoRegular(@size: 16px, @color: light-green);
            }
            .scheda {
              .set-font-latoBold(@size: 16px);
            }
            .info {
              padding-left: 5px;
              padding-right: 5px;
              width: 100% !important;
              .set-font-latoLight(@size: 16px);
            }
            .notbottone {
              margin-bottom: 10px;
              .set-font(@size: 16px, @color: orange)
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #shop {
      .carrello {
        #car {
          width: 15%;
        }
      }
      .indice {
        .link {
          padding-right: 5px;
          .set-font-latoMedium();
        }
      }
      .riga {
        .categoria {
          .set-font-latoLight(@size: 30px);
        }
        .cont {
          .vino {
            .set-font-title(@size: 25px);
            .nomeVino {
              .set-font-latoLight(@size: 30px);
            }
            .quantity {
              .set-font-latoRegular();
              .quantità {
              }
            }
            .immagine {
            }
            .desc {
              .set-font-latoLight();
            }
            .price {
              .set-font-latoRegular(@color: light-green);
            }
            .scheda {
              .set-font-latoBold();
            }
            .info {
              padding-left: 10px;
              padding-right: 10px;
              .set-font-latoLight();
            }
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    #shop {
      .carrello {
        .set-font-latoLight();
        #car {
          width: 15%;
        }
      }
      .indice {
        .link {
          padding-right: 5px;
          .set-font-latoMedium();
        }
      }
      .riga {
        .categoria {
          .set-font-latoLight(@size: 30px);
        }
        .cont {
          .vino {
            .set-font-title(@size: 25px);
            .nomeVino {
              .set-font-latoLight(@size: 30px);
            }
            .quantity {
              .set-font-latoRegular();
              .quantità {
              }
            }
            .immagine {
            }
            .desc {
              .set-font-latoLight();
            }
            .price {
              .set-font-latoRegular(@color: light-green);
            }
            .scheda {
              .set-font-latoBold();
            }
            .info {
              padding-left: 10px;
              padding-right: 10px;
              .set-font-latoLight();
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Shop.vue